module.exports = __webpack_public_path__ + "img/electronic_electric_enabled_selected.5b2d147d.svg";